module.exports = __webpack_public_path__ + "static/media/IconNonChecked.44d9a5ed.svg";